import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import RadioButtonGroup from '../Form/RadioButtonGroup';

const ProductSelectorOption = ({
  isSelected,
  name,
  onChange,
  title,
  subText,
  value,
}) => (
  <label className="product-selector-option__container">
    <input
      checked={isSelected}
      className="visually-hidden"
      name={name}
      onChange={onChange}
      type="radio"
      value={value}
    />
    <div
      className={classNames('product-selector-option', {
        'product-selector-option--selected': !!isSelected,
      })}
    >
      <div className="product-selector-option__title natural-heading--small">
        {title}
      </div>
      <div className="product-selector-option__sub-text subheading--small">
        {subText}
      </div>
    </div>
  </label>
);

ProductSelectorOption.propTypes = {
  isSelected: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  title: PropTypes.node.isRequired,
  subText: PropTypes.node,
  value: PropTypes.string.isRequired,
};

const ProductSelector = ({ name, title, options, className, onChange }) => (
  <div className="product-selector__container">
    {title && (
      <div className="product-selector__title subheading--small">{title}</div>
    )}
    <RadioButtonGroup
      defaultValue={options[0].value}
      inline
      name={name}
      className={className}
      render={({ selectedValue, setSelectedValue }) =>
        options.map(({ title, subText, value }) => (
          <ProductSelectorOption
            key={value}
            isSelected={selectedValue === value}
            name={name}
            onChange={() => {
              setSelectedValue(value);
              onChange(value);
            }}
            subText={subText}
            title={title}
            value={value}
          />
        ))
      }
    />
  </div>
);

ProductSelector.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func,
  title: PropTypes.node,
  options: PropTypes.arrayOf(ProductSelectorOption),
};

ProductSelector.defaultProps = {
  onChange: () => {}, // eslint-disable-line no-empty-function
};

export default ProductSelector;
